<template>
  <div class="date-time-wrapper">
    <input
      id="datetime"
      ref="input"
      type="datetime-local"
      v-model="localDateTime"
      @change="emitValue"
      @focus="openPicker"
      class="date-input"
    />
  </div>
</template>

<script>
export default {
  name: "MergedDateTimePicker",
  props: {
    modelValue: {
      type: [String, Date, null],
      default: null,
    },
  },
  data() {
    return {
      localDateTime: null,
    };
  },
  mounted() {
    if (this.modelValue) {
      // convert "YYYY-MM-DD HH:mm:ss" → "YYYY-MM-DDTHH:mm"
      this.localDateTime = this.modelValue.replace(" ", "T").slice(0, 16);
    }
  },
  methods: {
    emitValue() {
      if (this.localDateTime) {
        const [date, time] = this.localDateTime.split("T");
        const formatted = `${date} ${time}:00`;
        this.$emit("update:modelValue", formatted);
      }
    },
    openPicker(event) {
      event.target.showPicker?.();
    },
  },
};
</script>
<style scoped>
#datetime {
  width: 100%;
}
#datetime {
  width: 100%;
  border: none;
  font-size: 14px;
  outline: none;
}

#datetime:focus {
  border: none;
  box-shadow: none;
}
input[type="datetime-local"] {
  border: none;

  font-size: 14px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
}

/* أهم جزء لإخفاء الخط الأزرق / الأسود عند الضغط */
input[type="datetime-local"]:focus {
  outline: none !important;
  box-shadow: none !important;
  border: none;
}
</style>
